import styled from "styled-components";

export const BadgeStyled = styled.button`
  padding: 2px 5px;
  color: #ffbf1d;
  background-color: rgba(255, 191, 29, 0.08);
  font-size: 0.75em;
  border-radius: 10px;
  padding-top: 1px;
  padding-bottom: 2px;
  border: solid 1px #ffbf1d;
`;

export const ImgStyled = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 18px;
  /* border: solid 1px #353a50; */
`;

export const ImageInputStyled = styled.input`
  width: 48px;
  height: 48px;
  border-radius: 18px;
  border: solid 1px #353a50;
  cursor: pointer;
  color: transparent;
  background: transparent;
`;
export const ScoresStyled = styled.div`
  padding: 3px 12px;
  border-radius: 12px;
  background-color: #2a2e43;
  color: white;

  & > div:first-child {
    opacity: 0.5;
  }
`;
export const BalanceWallet = styled.div`
  padding: 10px;
  border-radius: 18px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05);
  background-color: #48cfad;
  color: #fff;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;
export const BalanceWalletToman = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const BalanceWalletText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
`;
export const AmountBalance = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
`;
export const Tooman = styled.div`
  font-size: 10px;
  margin-right: 35px;
`;
export const Icon = styled.div`
  width: 18px;
  height: 18px;
  margin-left: 5px;
  border-radius: 5px;
  border: solid 2px #fff;
`;
